import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Clienthad() {
  return (
    <section className="client_had p-100 text_color">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              <span>The Client</span> Had?
            </h2>
            <p>
              The client approached us to create an online version of the famous
              Spanish board game Parcheesi with additional features like an
              increased player count and more competitive game rules. few.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <div className="client_img">
              <StaticImage
                src="../../../images/case-studies/parcheesi/client.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={664}
                height={425}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Clienthad;
